import { render, staticRenderFns } from "./ReturnsTable.vue?vue&type=template&id=60091568&"
import script from "./ReturnsTable.vue?vue&type=script&lang=js&"
export * from "./ReturnsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports